import _ from "lodash";

export function removeNthElement<T>(arr: T[], n: number): T[] {
  // 配列の長さよりも大きいインデックスまたは負のインデックスが渡された場合は、配列をそのまま返す
  if (n >= arr.length || n < 0) {
    return arr;
  }

  return [...arr.slice(0, n), ...arr.slice(n + 1)];
}

export function addToNthElement<T>(elm: T, arr: T[], n: number): T[] {
  if (n > arr.length || n < 0) {
    return arr;
  }

  return [...arr.slice(0, n), elm, ...arr.slice(n)];
}

export function $doll(n: number) {
  return "$" + n;
}

if (import.meta.vitest) {
  const { it, expect } = import.meta.vitest;

  it("removeNthElement", () => {
    expect(removeNthElement([1, 2, 3], 1)).toEqual([1, 3]);
    expect(removeNthElement([1, 2, 3], 3)).toEqual([1, 2, 3]);
    expect(removeNthElement([1, 2, 3], -1)).toEqual([1, 2, 3]);
  });

  it("addToNthElement", () => {
    expect(addToNthElement(4, [1, 2, 3], 1)).toEqual([1, 4, 2, 3]);
    expect(addToNthElement(4, [1, 2, 3], 3)).toEqual([1, 2, 3, 4]);
    expect(addToNthElement(4, [1, 2, 3], -1)).toEqual([1, 2, 3]);
  });

  it("$doll", () => {
    expect($doll(1)).toEqual("$1");
  });
}

export const removeUndefinedFilterFn = (item: any): item is any =>
  item !== undefined;

if (import.meta.vitest) {
  const { it, expect } = import.meta.vitest;

  it("removeUndefinedFilterFn", () => {
    expect([1, undefined, 3].filter(removeUndefinedFilterFn)).toEqual([1, 3]);
  });
}

// set

export function uniq(arr: any[]) {
  return [...new Set(arr)];
}

export function removeDup<T>(objs: Record<string, any>[], key: string): T {
  return _.uniqBy(objs, (obj: any) => obj[key]) as T;
}

export function removeDupStrict<T>(objs: T[]): T[] {
  return _.uniqWith(objs, _.isEqual);
}

if (import.meta.vitest) {
  const { expect, it } = import.meta.vitest;

  it("removeDup", () => {
    expect(
      removeDup(
        [
          { key: 1, index: 2 },
          { key: 1, index: 2 },
        ],
        "index"
      )
    ).toStrictEqual([{ key: 1, index: 2 }]);
    expect(
      removeDup(
        [
          { key: 1, index: 2 },
          { key: 1, index: 2 },
          { key: 2, index: 2 },
        ],
        "key"
      )
    ).toStrictEqual([
      { key: 1, index: 2 },
      { key: 2, index: 2 },
    ]);
  });

  it("removeDupStrict", () => {
    expect(
      removeDupStrict([
        { a: 1, b: 1 },
        { a: 1, b: 2 },
        { a: 1, b: 2 },
        { a: 2, b: 1 },
        { a: 2, b: 2 },
      ])
    ).toStrictEqual([
      { a: 1, b: 1 },
      { a: 1, b: 2 },

      { a: 2, b: 1 },
      { a: 2, b: 2 },
    ]);
    expect(
      removeDupStrict([
        { category: "shop_helper", carrier: "docomo" },
        { category: "shop_helper", carrier: "docomo" },
        { category: "shop_helper", carrier: "docomo" },
      ])
    ).toStrictEqual([{ category: "shop_helper", carrier: "docomo" }]);
  });
}
